import React from 'react';

const PinIcon: React.FC<React.SVGProps<SVGSVGElement>> = () => {
  return (
    <svg
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.2082 6.5L11.8663 9.85313C12.1513 10.645 12.2694 11.9713 11.0419 13.6031C10.9561 13.7179 10.8465 13.8127 10.7206 13.8812C10.5947 13.9497 10.4555 13.9902 10.3125 14C10.2888 14 10.2657 14 10.2419 14C10.1105 14 9.9804 13.9741 9.859 13.9239C9.7376 13.8736 9.62731 13.7998 9.53442 13.7069L6.51817 10.6875L3.8538 13.3538C3.75998 13.4476 3.63273 13.5003 3.50005 13.5003C3.36736 13.5003 3.24012 13.4476 3.1463 13.3538C3.05248 13.2599 2.99977 13.1327 2.99977 13C2.99977 12.8673 3.05248 12.7401 3.1463 12.6463L5.81255 9.98188L2.7938 6.96313C2.69457 6.86378 2.61738 6.74465 2.56725 6.61349C2.51712 6.48233 2.49517 6.34208 2.50283 6.20187C2.5105 6.06167 2.5476 5.92465 2.61173 5.79974C2.67586 5.67483 2.76558 5.56482 2.87505 5.47688C4.4638 4.195 5.98442 4.44688 6.65005 4.65563L10 1.29375C10.0929 1.20087 10.2032 1.12719 10.3245 1.07692C10.4458 1.02665 10.5759 1.00078 10.7072 1.00078C10.8386 1.00078 10.9686 1.02665 11.09 1.07692C11.2113 1.12719 11.3216 1.20087 11.4144 1.29375L15.2075 5.08625C15.395 5.27369 15.5004 5.52789 15.5005 5.793C15.5006 6.0581 15.3955 6.3124 15.2082 6.5Z"
        fill="#5C6469"
      />
    </svg>
  );
};

export default PinIcon;
